<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="3.841" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
      <path d="M0 1.92a1.921 1.921 0 113.842.002A1.921 1.921 0 010 1.92M0 8a1.921 1.921 0 113.842.002A1.921 1.921 0 010 8m0 6.08a1.921 1.921 0 113.842.002A1.921 1.921 0 010 14.08" fill="#9babc5"></path>
    </svg>
</template>
<script>
    export default { name: 'svg-1'}
</script>
